import { Input } from '@cobliteam/ui/form';
import { useDebounce } from '@cobliteam/ui/hooks';
import Icon from '@cobliteam/ui/icons';
import { useEffect, useState } from 'react';

export interface DataTableSearchInputProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}

const DataTableSearchInput = ({ value, placeholder, onChange }: DataTableSearchInputProps) => {
  const [searchValue, setSearchValue] = useState<string>(value);
  const debouncedValue = useDebounce(searchValue, 500);

  useEffect(() => {
    onChange(debouncedValue);
  }, [debouncedValue]);

  // Add effect to update internal state when prop changes
  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  return (
    <Input
      data-testid='datatable-search'
      startIcon={<Icon name='search' />}
      placeholder={placeholder}
      value={searchValue}
      className='!border-gray-7 w-full'
      endIcon={
        searchValue ? (
          <button type='button' data-testid='clear-search' onClick={() => setSearchValue('')}>
            <Icon name='x' size='xs' />
          </button>
        ) : null
      }
      onChange={(e) => setSearchValue(e.target.value)}
      size='sm'
    />
  );
};

export default DataTableSearchInput;
